// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const baseURL = process.env.REACT_APP_BASE_URL;

// const useAxios = () => {
//     const navigate = useNavigate();

//     const tokenData = localStorage?.getItem('authTokens');

//     if (tokenData === undefined) {
//         navigate('/');
//     }

//     const { access_token, refresh_token } = tokenData && tokenData !== '' ? JSON.parse(tokenData) : { access_token: '', refresh_token: '' };
//     const headers = {
//         Authorization: `Bearer ${access_token}`,
//         "Access-Control-Allow-Origin": '*',
//         withCredentials: false,
//     };

//     const axiosInstance = axios.create({
//         baseURL,
//         headers,
//     });

//     axiosInstance.interceptors.response.use(
//         (response) => {
//             return response;
//         },
//         async (error) => {
//             const originalRequest = error.config;
//             if (error.response && error.response.status === 401 && error.response.data.error === 'TOKEN_EXPIRED') {
//                 const token = await getNewAccessToken(refresh_token);
//                 originalRequest.headers['Access-Control-Allow-Origin'] = `*`;

//                 if (token) {
//                     axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
//                     originalRequest.headers['Authorization'] = `Bearer ${token}`;
//                     return axiosInstance(originalRequest);
//                 }
//             } else if (error.response && error.response.status === 401 && error.response.data.error === 'SESSION_EXPIRED') {
//                 localStorage.clear();
//                 navigate('/');
//             }else{
//                 return error;
//             }
//             // return Promise.reject(error);
//         }
//     );

//     return {axiosInstance};
// };

// const getNewAccessToken = async (refreshToken: string) => {
//     let result = await fetch(baseURL + '/auth/refresh-token', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//             refresh_token: refreshToken
//         })
//     });
//     let json = await result.json();
//     localStorage.setItem('authTokens', JSON.stringify(json));
//     return json.access_token;
// };

// export default useAxios;

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logOutUserFunc } from "../redux/userState"; // you'll need this action

const baseURL = process.env.REACT_APP_BASE_URL;

const useAxios = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const tokenData = localStorage.getItem("authTokens");

  const { access_token, refresh_token } = tokenData
    ? JSON.parse(tokenData)
    : { access_token: "", refresh_token: "" };

  const axiosInstance = axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });

  const forceLogout = () => {
    localStorage.clear();
    dispatch(logOutUserFunc()); // <-- THIS is what was missing
    navigate("/");
  };

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (
        error.response?.status === 401 &&
        error.response?.data?.error === "TOKEN_EXPIRED"
      ) {
        const newToken = await getNewAccessToken(refresh_token);
        if (newToken) {
          axiosInstance.defaults.headers.common["Authorization"] =
            `Bearer ${newToken}`;
          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
          return axiosInstance(originalRequest);
        } else {
          forceLogout(); // refresh failed too
        }
      } else if (
        error.response?.status === 401 &&
        error.response?.data?.error === "SESSION_EXPIRED"
      ) {
        forceLogout();
      }

      return Promise.reject(error); // always reject so calling code knows it failed
    },
  );

  return { axiosInstance };
};

const getNewAccessToken = async (refreshToken: string) => {
  try {
    const result = await fetch(baseURL + "/auth/refresh-token", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
    if (!result.ok) return null; // refresh token itself expired
    const json = await result.json();
    localStorage.setItem("authTokens", JSON.stringify(json));
    return json.access_token;
  } catch {
    return null;
  }
};

export default useAxios;
